<script lang="ts">
  import type { FocusItem, FocusLayer } from '../../shared/focus-manager/focus-types';
  import { registerFocus } from '../../shared/focus-manager/focus.action.svelte.js';

  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  export function focus() {
    button.focus();
  }

  let button: HTMLElement;
</script>

<button
  type="button"
  {...$$restProps}
  class="button {$$props.class ?? ''}"
  bind:this={button}
  on:click
  data-focusName={focusName}
  data-focusLayer={focusLayer}
  use:registerFocus={{ focusName, focusLayer }}
>
  <slot />
</button>

<style module>
  .button {
    color: #f0f0f0;
    color: var(--button-color);
    background: #424447;
    background: var(--button-background-color);
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: fit-content;
    gap: 0.5rem;
    padding: 0.6rem 1rem;
    font-size: 1rem; /* Fallback for older browsers */
    font-size: clamp(0.875rem, 1.5vw + 0.5rem, 1.125rem);
    font-weight: 700;
  }

  @media (prefers-reduced-motion: no-preference) {
    .button {
      transition: 0.3s ease-in-out;
      transition-property: background-color, color;
    }
  }

  .button:focus {
    outline: 2px solid #ffffff; /* Fallback for older browsers */
    outline: var(--button-contrast-outline);
  }

  @supports selector(:focus-visible) {
    /* Don't show the outline on focus... */
    .button:focus {
      outline: none;
    }

    /* ...but show it on focus-visible */
    .button:focus-visible {
      outline: 2px solid #ffffff; /* Fallback for older browsers */
      outline: var(--button-contrast-outline);
    }
  }

  @media (prefers-contrast: more) {
    .button:active {
      outline: var(--button-contrast-outline);
    }
  }

  @media (hover: hover) {
    .button:enabled:hover {
      color: #000000;
      color: var(--button-hover-color);
      background-color: #ffffff;
      background-color: var(--button-hover-background-color);
    }

    @media (prefers-contrast: more) {
      .button:enabled:hover {
        outline: var(--button-contrast-outline);
        outline-offset: 4px;
      }
    }
  }

  .button:active {
    color: #000000;
    color: var(--button-hover-color);
    background-color: #ffffff;
    background-color: var(--button-hover-background-color);
  }

  .button:disabled {
    cursor: not-allowed;
  }
</style>
